import { render, staticRenderFns } from "./analysisHospitaliPieChart.vue?vue&type=template&id=58be5e32&scoped=true"
import script from "./analysisHospitaliPieChart.vue?vue&type=script&lang=js"
export * from "./analysisHospitaliPieChart.vue?vue&type=script&lang=js"
import style0 from "./analysisHospitaliPieChart.vue?vue&type=style&index=0&id=58be5e32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58be5e32",
  null
  
)

export default component.exports